import React, { useEffect, useState } from 'react';
import './sidenav.scss';
import Modal from './feature-modal.tsx'; 
import { IconContext } from 'react-icons';
import * as AiIcons from 'react-icons/ai';
import * as FaIcons from 'react-icons/fa';
import {
  Box,
  Collapse,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Menu,
  MenuItem
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NavBar = ({ selected }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [expandedItems, setExpandedItems] = useState({});
  const [moreAnchor, setMoreAnchor] = useState(null);
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const SidebarData = require('./sidebarData').default;
  const navigate = useNavigate();
  const storedUserDetails = localStorage.getItem("userdetails");
  const userDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;
  const companiesId = userDetails?.companiesId || userDetails?.companies_id; 
  const mainTabs = SidebarData.slice(0, 4);
  const moreTabs = SidebarData.slice(4);
  const activeTabIndex = mainTabs.findIndex(item => item.title === selected);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleExpand = (title) => {
    setExpandedItems(prev => ({ ...prev, [title]: !prev[title] }));
  };

  const handleMobileNavigate = (fullPath) => {
    try {
      const cleanPath = fullPath.replace(window.location.origin, '');
      navigate(cleanPath);
    } catch (error) {
      navigate(fullPath);
    }
  };

  const renderSidebarItem = (item, index) => {
    const hasSubNav = item.subNav?.length > 0;
    const isExpanded = expandedItems[item.title];
    const isActive = item.title === selected;

    return (
      <React.Fragment key={index}>
        <a
          href={hasSubNav ? '#' : item.path}
          className={isActive ? 'highlight' : 'sidebar-section'}
          onClick={(e) => {
            if (item.title === 'Orders' && companiesId != 1) {
              e.preventDefault();
              setOrderModalOpen(true);
              return;
            }

            if (hasSubNav) {
              e.preventDefault();
              toggleExpand(item.title);
            }
          }}
        >
          <IconContext.Provider value={{ color: isActive ? '#000' : '#fff', size: '26px' }}>
            {item.icon}
          </IconContext.Provider>

          <span style={{ marginLeft: 10 }}>{item.title}</span>

          {hasSubNav && (
            <span style={{ marginLeft: 'auto' }}>
              <IconContext.Provider value={{ color: isActive ? '#000' : '#fff' }}>
                {isExpanded ? <FaIcons.FaMinus /> : <FaIcons.FaPlus />}
              </IconContext.Provider>
            </span>
          )}
        </a>

        {hasSubNav && (
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            {item.subNav.map((subItem, subIndex) => {
              const isSubActive = subItem.title === selected;
              return (
                <a
                  key={subIndex}
                  href={subItem.path}
                  className={isSubActive ? 'highlight' : 'sidebar-section'}
                >
                  <IconContext.Provider value={{ color: isSubActive ? '#000' : '#fff', size: '24px' }}>
                    {subItem.icon}
                  </IconContext.Provider>
                  <span style={{ marginLeft: 10 }}>{subItem.title}</span>
                </a>
              );
            })}
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  const renderIcon = (icon) =>
    React.cloneElement(icon, {
      size: 28,
    });

  return (
    <>
      {windowWidth > 600 && (
        <IconContext.Provider value={{ color: '#fff' }}>
          <div className="sidebar">
            {SidebarData.map((item, index) => renderSidebarItem(item, index))}
          </div>
        </IconContext.Provider>
      )}

      {windowWidth <= 600 && (
        <>
          <Paper
            elevation={10}
            sx={{
              position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1300
            }}
          >
            <BottomNavigation
              value={activeTabIndex}
              showLabels
              sx={{
                background: 'linear-gradient(1turn, rgb(211, 211, 211), rgb(255, 255, 255))',
                '& .MuiBottomNavigationAction-root': { color: '#000000ff', minWidth: 0, padding: '8px 0' },
                '& .MuiBottomNavigationAction-root.Mui-selected': {
                  background: 'linear-gradient(135deg, #000000 20%, #e63946 100%) ',
                  color: '#ffffff', borderRadius: '10px'
                },
                '& .MuiBottomNavigationAction-label': { fontSize: '0.85rem', fontWeight: 600 },
                '& .MuiSvgIcon-root': { fontSize: '1.8rem' },
                borderRadius: '7px'
              }}
            >
              {mainTabs.map((item, index) => (
                <BottomNavigationAction
                  key={index}
                  label={item.title}
                  icon={renderIcon(item.icon)}
                  onClick={() => {
                    if (item.title === 'Orders' && companiesId != 1) {
                      setOrderModalOpen(true);
                    } else {
                      handleMobileNavigate(item.path);
                    }
                  }}
                />
              ))}

              {moreTabs.length > 0 && (
                <BottomNavigationAction
                  label="More"
                  icon={<AiIcons.AiOutlineMore size={28} />}
                  onClick={(e) => setMoreAnchor(e.currentTarget)}
                  sx={{
                    '&.Mui-selected': { backgroundColor: 'transparent !important', color: '#ffffff !important' }
                  }}
                />
              )}
            </BottomNavigation>
          </Paper>

          <Menu
            anchorEl={moreAnchor}
            open={Boolean(moreAnchor)}
            onClose={() => setMoreAnchor(null)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          >
            {moreTabs.map((item, index) => {
              const isActive = item.title === selected;
              return (
                <MenuItem
                  key={index}
                  onClick={() => {
                    handleMobileNavigate(item.path);
                    setMoreAnchor(null);
                  }}
                  sx={{
                    backgroundColor: isActive ? '#d44a41 !important' : 'inherit',
                    color: isActive ? '#ffffff !important' : 'inherit',
                    '&:hover': { backgroundColor: isActive ? '#d44a41 !important' : 'rgba(0, 0, 0, 0.04)' }
                  }}
                >
                  <IconContext.Provider value={{ size: '20px' }}>
                    {item.icon}
                  </IconContext.Provider>
                  <span style={{ marginLeft: 10 }}>{item.title}</span>
                </MenuItem>
              );
            })}
          </Menu>
        </>
      )}

      <Modal
        isOpen={orderModalOpen}
        onClose={() => setOrderModalOpen(false)}
        message="You do not have access to Orders feature."
      />
    </>
  );
};

export default NavBar;